<template>
  <div class="popup-overlayer">
    <div class="popup">
      <a @click="$emit('close')" href="javascript:void(0)" class="close-btn"><i class="fas fa-times"></i></a>
      <h2>{{barrier_name}}</h2>
      <canvas id="video_player" style="width: 640px; height: 480px; display: block;"></canvas>

      <div style="margin-top: 20px;">
        <button v-if="permanent_open_bool == false" style="margin-bottom:5px" @click="opening(barrier_id, barrier_name, refresh)" class="button small orange with-icon" title="Kinyitás"><i class="fa fa-lock-open"></i>Kinyitás</button>
        
        <!--Hack NCIOM miatt-->
        <button v-if="permanent_open_bool == false && nciom_control_seq_id == false" style="margin-bottom:5px" @click="permanentOpening(barrier_id, 0, barrier_name, refresh)" class="button small orange with-icon" title="Tartós nyitás"><i class="fa fa-lock-open"></i>Tartós nyitás</button>

        <button v-if="permanent_open_bool != false" style="margin-bottom:5px" @click="normalOperationDatetime(barrier_id, refresh)" class="button small orange with-icon" title="Normál üzem időpont"><i class="fa fa-lock"></i>Normál üzem időpont</button>
        <button v-if="permanent_open_bool != false" style="margin-bottom:5px" @click="normalOperationNow(barrier_id, barrier_name, refresh)" class="button small orange with-icon" title="Normál üzem azonnal"><i class="fa fa-lock"></i>Normál üzem azonnal</button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  props: {
    barrier_id: {
      type: [Number, String, Boolean],
      required: true
    },
    opening: {
      type: [Function],
      required: true
    },
    permanentOpening: {
      type: [Function],
      required: true
    },
    normalOperationDatetime: {
      type: [Function],
      required: true
    },
    normalOperationNow: {
      type: [Function],
      required: true
    }
  },
  data() {
    return {
      jsmpeg: '',
      video_stream: '',
      barrier_name: '',
      open: 0,
      permanent_open_bool: false,
      nciom_control_seq_id: ''
    };
  },
  mounted() {
    var _this = this;
    Vue.nextTick(() => {
      _this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('remote_open/camera_view/' + _this.barrier_id + '/' + _this.$root.user.apikey, {
          method: 'GET',
          success: function(response) {
            if (response.camera_video_stream !== false) {
              _this.barrier_name = response.barrier_name;
              _this.video_stream = response.camera_video_stream;
              _this.open = response.open;
              _this.permanent_open_bool = response.permanent_open_bool;
              _this.nciom_control_seq_id = response.nciom_control_seq_id;
              var canvas = document.getElementById('video_player');
              _this.jsmpeg = new JSMpeg.Player(_this.video_stream + '?key='+_this.$root.user.apikey, { canvas });
            } else {
              _this.$emit('close');
            }
          }
        });
      });
    });
  },
  methods: {
    refresh: function() {
      var _this = this;

      _this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('remote_open/camera_view/' + _this.barrier_id + '/' + _this.$root.user.apikey, {
          method: 'GET',
          success: function(response) {
            _this.open = response.open;
            _this.permanent_open_bool = response.permanent_open_bool;
          }
        });
      });
    }
  },
  destroyed() {
    if (this.jsmpeg != '')
      this.jsmpeg.destroy();
  }
}
</script>



// WEBPACK FOOTER //
// camera_view_popup.vue?2ca02448